(() => {
  function initSwiper(root) {
    const swiperEl = root.querySelector('[data-sss-v2-swiper]');
    if (!swiperEl) return;
    if (typeof window.Swiper === 'undefined') return;

    // Avoid double-init
    if (swiperEl.dataset.sssV2SwiperInit === 'true') return;
    swiperEl.dataset.sssV2SwiperInit = 'true';

    const prevEl = swiperEl.querySelector('[data-sss-v2-prev]');
    const nextEl = swiperEl.querySelector('[data-sss-v2-next]');

    // 1.3 slides visible (mobile)
    // NOTE: Swiper uses slidesPerView; 1.3 gives the peeking card effect.
    new window.Swiper(swiperEl, {
      slidesPerView: 1.5,
      spaceBetween: 26,
      slidesOffsetAfter: 15,
      slidesOffsetBefore: 15,
      centeredSlides: false,
      watchOverflow: true,
      navigation: prevEl && nextEl ? { prevEl, nextEl } : undefined,
      pagination: {
        el: swiperEl.querySelector('.swiper-pagination'),
        clickable: true
      },
      breakpoints: {
        768: {
          slidesPerView: 2.8,
          spaceBetween: 20
        }
      }
    });
  }

  function initVideoToggle(root) {
    const videos = Array.from(root.querySelectorAll('video.sss-v2__video'));
    if (videos.length === 0) return;

    function getVideoWrapper(video) {
      return (
        video.closest('.sss-v2__media') ||
        video.closest('.sss-v2__slide-media') ||
        video.parentElement
      );
    }

    function setPlayingState(video) {
      const wrapper = getVideoWrapper(video);
      if (!wrapper) return;
      wrapper.classList.toggle('is-playing', !video.paused && !video.ended);
    }

    function pauseOthers(except) {
      videos.forEach(v => {
        if (v !== except && !v.paused) v.pause();
      });
    }

    videos.forEach(video => {
      // Overlay click should behave like clicking the video
      const wrapper = getVideoWrapper(video);
      const playBtn = wrapper ? wrapper.querySelector('[data-sss-v2-play]') : null;
      if (playBtn) {
        playBtn.addEventListener('click', (e) => {
          e.preventDefault();
          video.click();
        });
      }

      video.addEventListener('click', () => {
        // Pause any other playing videos first
        pauseOthers(video);

        if (video.paused) {
          const playPromise = video.play();
          if (playPromise && typeof playPromise.catch === 'function') {
            playPromise.catch(() => {
              // Some browsers require user gesture; click is a gesture, but just in case.
            });
          }
        } else {
          video.pause();
        }
      });

      video.addEventListener('play', () => {
        pauseOthers(video);
        setPlayingState(video);
      });
      video.addEventListener('pause', () => setPlayingState(video));
      video.addEventListener('ended', () => setPlayingState(video));

      // Initial state
      setPlayingState(video);
    });
  }

  function initSection(root) {
    initSwiper(root);
    initVideoToggle(root);
  }

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-sss-v2]').forEach(initSection);
  });

  // Theme editor support (Shopify)
  document.addEventListener('shopify:section:load', (event) => {
    const root = event.target;
    if (root && root.matches && root.matches('[data-sss-v2]')) {
      initSection(root);
    } else if (root) {
      const nested = root.querySelector('[data-sss-v2]');
      if (nested) initSection(nested);
    }
  });
})();

